import { useStore } from '@nanostores/react';
import { useCallback } from 'react';

import { type Asset } from '@/services/db/asset/entity';

import { $assetLibraryModal } from './store';
import { type AssetLibraryOptions } from './types';

export function useAssetLibrary() {
  const modalState = useStore($assetLibraryModal);

  const open = useCallback((options?: AssetLibraryOptions) => {
    $assetLibraryModal.set({
      isOpen: true,
      callback: null,
      options: options ?? null,
    });
  }, []);

  const selectAsset = useCallback((options?: AssetLibraryOptions): Promise<Asset | null> => {
    return new Promise((resolve) => {
      $assetLibraryModal.set({
        isOpen: true,
        callback: resolve,
        options: options ?? null,
      });
    });
  }, []);

  const onSelect = useCallback((asset: Asset) => {
    const currentState = $assetLibraryModal.get();
    if (currentState.callback != null) {
      currentState.callback(asset);
    }
    $assetLibraryModal.set({
      isOpen: false,
      callback: null,
      options: null,
    });
  }, []);

  const onClose = useCallback(() => {
    const currentState = $assetLibraryModal.get();
    if (currentState.callback != null) {
      currentState.callback(null);
    }
    $assetLibraryModal.set({
      isOpen: false,
      callback: null,
      options: null,
    });
  }, []);

  return {
    open,
    selectAsset,
    onSelect,
    onClose,
    isOpen: modalState.isOpen,
    options: modalState.options,
  };
}
